import HeaderBack from "@/components/fragments/HeaderBack";
import CustomerDetailComponent from "@/features/Customer/components/Detail";
import { getStoredUserData } from "@/utils/getStoredUser";
import { useParams } from "react-router-dom";

export default function CustomerDetail() {
  const { id } = useParams<{ id: string }>();
  const userData = getStoredUserData();
  let email = userData?.email || "";

  return (
    <div className="md:w-[80vw] lg:w-[70vw] mx-auto h-screen">
      <HeaderBack text="Detail Customer" url="/customer" />
      <CustomerDetailComponent id={id} email={email} />
    </div>
  );
}
